import { filePath } from "@/utils/variables";
export default function Image({
  fileName,
  alt,
  desktopWidth,
  mobileWidth,
  desktopHeight,
  mobileHeight,
  className,
  imgStyle,
  isBannerImg,
  fileFormat,
  isLazyLoad,
  has2XWebp,
}) {
  return (
    <figure className={className}>
      {isBannerImg ? (
        <picture>
          <source
            media="(max-width: 749px)"
            srcSet={`${filePath}/webp/mobile/${fileName}@2x.webp`}
            type="image/webp"
            width={mobileWidth}
            height={mobileHeight}
          ></source>
          <source
            media="(max-width: 749px)"
            srcSet={`${filePath}/images/mobile/${fileName}.${fileFormat} 1x, ${filePath}/images/mobile/${fileName}@2x.${fileFormat} 2x`}
            type={`image/${fileFormat}`}
            width={mobileWidth}
            height={mobileHeight}
          ></source>
          <source
            srcSet={`${filePath}/webp/desktop/${fileName}@2x.webp`}
            type="image/webp"
            width={desktopWidth}
            height={desktopHeight}
          ></source>
          <source
            srcSet={`${filePath}/images/desktop/${fileName}.${fileFormat} 1x, ${filePath}/images/desktop/${fileName}@2x.${fileFormat} 2x`}
            type={`image/${fileFormat}`}
            width={desktopWidth}
            height={desktopHeight}
          ></source>
          <img
            loading={`${isLazyLoad ? "lazy" : "eager"}`}
            fetchpriority={`${isLazyLoad ? "auto" : "high"}`}
            src={`${filePath}/images/desktop/${fileName}.${fileFormat}`}
            alt={alt}
            width={desktopWidth}
            height={desktopHeight}
            className={`${imgStyle}`}
          />
        </picture>
      ) : (
        <>
          {has2XWebp && (
            <source
              srcSet={`${filePath}/webp/desktop/${fileName}.webp`}
              type="image/webp"
              width={desktopWidth}
            ></source>
          )}
          <img
            loading={`${isLazyLoad && "lazy"}`}
            src={`${filePath}/images/desktop/${fileName}.${fileFormat}`}
            alt={alt}
            width={desktopWidth}
            height={desktopHeight}
            className="img"
          />
        </>
      )}
      <style jsx>{`
        img {
          display: block;
          object-fit: cover;
        }
      `}</style>
    </figure>
  );
}
Image.defaultProps = {
  fileName: "",
  alt: "Image",
  className: "",
  isBannerImg: true,
  isLazyLoad: true,
};
